module.exports = __webpack_public_path__ + "img/DJI_0008.e1592e57.jpg";